import { STATUS, getStatusId } from '@btime/constants'
import { generateContext } from '@btime/react-contexts'
import React, { useState } from 'react'

import { formatApiDate } from '../../../../utils/helpers/date'
import { useIsBulkExecution, useServiceOrder } from '../_load/ServiceOrderLoader'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useExecutionForm = () => React.useContext(StateContext)
export const useExecutionFormActions = () => React.useContext(ActionsContext)

const Form = ({ children }) => {
  const serviceOrder = useServiceOrder()
  const isBulk = useIsBulkExecution()
  // Em execução em massa não fica marcado um único momento de "início da
  // execução" (são várias atividades, cada uma com seu próprio histórico);
  // o backend aplica a conclusão atividade por atividade quando o usuário
  // confirma.
  const [form, setForm] = useState({
    currentStatus: serviceOrder?.status?.name,
    events: isBulk ? [] : [{ statusId: getStatusId(STATUS.EXECUTION), eventDate: formatApiDate(new Date()) }]
  })

  return (
    <Provider state={form} actions={{ setForm }}>
      {children}
    </Provider>
  )
}

export default Form
